import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EmailResendRequest } from '../../interface/email-resend.interface';
import { BridgeService } from '../bridge/bridge.service';
import { StoreService } from '../store/store.service';

@Injectable({
    providedIn: 'root',
})
export class EventsubscriptionService {
    constructor(private _bridge: BridgeService, private _store: StoreService) {}

    /**
     * Method to fetch subscribeb events
     * @param data contains orgId, eventType, fetchSize, pagingState
     * @param callbacks contains success and failure calls
     */
    getSubscribedEvents = (data: { orgId: string; eventType?: string[]; groupId?: string; fetchSize: number; pagingState: string }) => {
        return new Observable(observer => {
            this._bridge.getSubscribedEvents(
                data,
                res => {
                    observer.next(res);
                    observer.complete();
                },
                res => {
                    observer.error(res);
                    observer.complete();
                }
            );
        });
    };

    /**
     * Method to fetch event definations
     * @param callbacks contains success and failure calls
     */
    getEventDefinitions = async (
        forSubscription: boolean,
        callbacks?: { successCallback: (res) => void; failureCallback: (res) => void }
    ) => {
        const response = await this._store.publicScope.fetchValues(() => {
            return new Promise(resolve => {
                this._bridge.getEventTypes(
                    forSubscription,
                    res => {
                        resolve(res);
                    },
                    res => {
                        callbacks.failureCallback(res);
                    }
                );
            });
        }, 'eventDefinitions');
        if (callbacks?.successCallback) {
            callbacks.successCallback(response?.eventDefinitions);
        } else {
            return response?.eventDefinitions;
        }
    };

    getEventTypes = (forSubscription: boolean) => {
        return new Observable(observer => {
            this._bridge.getEventTypes(
                forSubscription,
                res => {
                    const eventTypes = {
                        ASSET: [],
                        USER: [],
                    };
                    res.eventTypes.forEach(item => {
                        if (item.type === 'mapro') {
                            eventTypes['ASSET'].push(item);
                        } else {
                            eventTypes['USER'].push(item);
                        }
                    });
                    observer.next(eventTypes);
                    observer.complete();
                },
                err => {
                    observer.error(err);
                    observer.complete();
                }
            );
        });
    };

    /**
     * Method to create event subscriptions
     * @param data: contains event payload
     * @param callbacks: contains success and failure callbacks
     */
    createEventSubscriptions = (data: any) => {
        return new Observable(observer => {
            this._bridge.createEventSubscriptions(
                data,
                res => {
                    observer.next(res);
                    observer.complete();
                },
                res => {
                    observer.error(res);
                    observer.complete();
                }
            );
        });
    };
    /**
     * Method to create event subscriptions
     * @param data: contains event payload
     * @param callbacks: contains success and failure callbacks
     */
    editEventSubscriptions = (data: any) => {
        return new Observable(observer => {
            this._bridge.editEventSubscriptions(
                data,
                res => {
                    observer.next(res);
                    observer.complete();
                },
                res => {
                    observer.error(res);
                    observer.complete();
                }
            );
        });
    };
    /**
     * Method to delete event subscription
     * @param data: contains event payload
     * @param callbacks: contains success and failure callbacks
     */
    deleteEventSubscription = (data: { orgId: string; eventType: string; subscriptionId: string; groupId?: string }) => {
        return new Observable(observer => {
            this._bridge.deleteEventSubscription(
                data,
                res => {
                    observer.next(res);
                    observer.complete();
                },
                res => {
                    observer.error(res);
                    observer.complete();
                }
            );
        });
    };
    /**
     * Method to fetch email notifications
     * @param data contains groupId, eventType, subscriptionId, fromdate,fetchsize, pagingstate, status and mailId
     * @param callbacks contains success and failure calls
     */
    getEmailNotifications = (data: {
        groupId: string;
        eventType: string;
        subscriptionId: string;
        size: number;
        pageState: any;
        fromDate: string;
        toDate: string;
        status: string;
        mailId: string;
        noAlerts: boolean;
    }) => {
        return new Observable(observer => {
            this._bridge.getEmailNotifications(
                data,
                res => {
                    observer.next(res);
                    observer.complete();
                },
                res => {
                    observer.error(res);
                    observer.complete();
                }
            );
        });
    };
    /**
     * Method to generate Email Report
     * @param data Contains groupId, eventType, subscriptionId, fromdate, todate, status(sent or bounced), and emailId.
     */
    getEmailReport = (data: {
        groupId: string;
        eventType: string;
        subscriptionId: string;
        fromDate: string;
        toDate: string;
        status: string;
        mailId: string;
        noAlerts: boolean;
    }) => {
        return new Observable(observer => {
            this._bridge.getEmailReport(
                data,
                res => {
                    observer.next(res);
                    observer.complete();
                },
                res => {
                    observer.error(res);
                    observer.complete();
                }
            );
        });
    };
    /**
     * Method to resend email
     * @param data Contains orgId, createdOn, messageId, emailId of the existing email delivery record

     * @param callbacks contains success and failure calls
     */
    resendEmail = (data: EmailResendRequest) => {
        return new Observable(observer => {
            this._bridge.resendMail(
                data,
                res => {
                    observer.next(res);
                    observer.complete();
                },
                res => {
                    observer.error(res);
                    observer.complete();
                }
            );
        });
    };
}
